import React from 'react';
import { RichContent } from './RichContent';
import { Button } from './Button';
import PropTypes from "prop-types";

export const ServicesIconElement = (props) => {

	return (
		<div>
			{ props.image && <img className="icon-list__image" src={props.image} alt="Props.image"/> }
			{ props.text && <RichContent dangerous={props.text}/> }
			{ props.button && <Button label={props.button.label} link={props.button.link} color={ props.color } textColor={props.textColor}/> }
		</div>

	);
};


ServicesIconElement.propTypes = {
	image: PropTypes.string,
	text: PropTypes.string,
	button: PropTypes.object
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/elements/ServicesIconElement.js